import type { PayersByService } from 'api/payers/types';
import type { DropdownOption } from 'constants/_types/DropdownOptions';

export const parsePayersByServiceToDropdown = (payers: PayersByService[] | undefined, selfPayerLabel: string): DropdownOption[] => {
  if (!payers) return [];

  return payers.map(payer => ({ value: payer.id, label: payer.company?.name ?? selfPayerLabel }));
};
